import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface SeguimientoActividadPayload {
  id_actividad: number;
  observacion: string;
  estado?: number;
}

export interface SeguimientoActividad {
  id?: number;
  id_actividad: number;
  observacion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface SeguimientoActividadResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class SeguimientoActividadService {
  private readonly apiUrl = `${environment.apiUrl}/api/seguimiento_actividad`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<SeguimientoActividad[]> {
    return this.http.get<SeguimientoActividad[]>(this.apiUrl, { withCredentials: true });
  }

  getById(id: number): Observable<SeguimientoActividad> {
    return this.http.get<SeguimientoActividad>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // 👇 el que realmente usa el modal de seguimiento por actividad
  getByIdActividad(id_actividad: number): Observable<SeguimientoActividad[]> {
    return this.http.get<SeguimientoActividad[]>(`${this.apiUrl}/actividad/${id_actividad}`, { withCredentials: true });
  }

  create(payload: SeguimientoActividadPayload): Observable<SeguimientoActividadResponse> {
    return this.http.post<SeguimientoActividadResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  update(id: number, payload: Partial<SeguimientoActividadPayload>): Observable<SeguimientoActividadResponse> {
    return this.http.put<SeguimientoActividadResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  inactivar(id: number): Observable<SeguimientoActividadResponse> {
    return this.http.put<SeguimientoActividadResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  activar(id: number): Observable<SeguimientoActividadResponse> {
    return this.http.put<SeguimientoActividadResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}